import type { Slide } from '@features/powerpoint';
import { chartOptionsToBase64Svg } from '@features/powerpoint';
import { buyerChartOptions } from '@features/campaigns/subdomains/cpg/components/Summary/chart-options/buyer-chart-options';
import { themeV2 } from '../../../../domain/theme-v2';
import { DEFAULT_FONT } from '../../../../utils/constants-v2';
import { contentSlideHeaderV2 } from '../../../../utils/slide-header-v2';

const CHART_WIDTH = 1200;
const CHART_HEIGHT = 400;

type NewVsExistingBuyersSlideV2Props = {
  slideMaster: string;
  newBuyerPercentage: number;
  existingBuyerPercentage: number;
};

export const newVsExistingBuyersSlideV2 = (
  props: NewVsExistingBuyersSlideV2Props
): Slide => {
  const chartSvg = chartOptionsToBase64Svg({
    chartOptions: buyerChartOptions({
      existingBuyerPercentage: props.existingBuyerPercentage,
      newBuyerPercentage: props.newBuyerPercentage,
    }),
    width: CHART_WIDTH,
    height: CHART_HEIGHT,
  });

  return {
    slideMaster: props.slideMaster,
    images: [
      {
        data: chartSvg,
        x: 0.33,
        y: 1.7,
        w: 12.67,
        h: 4,
      },
    ],
    texts: [
      contentSlideHeaderV2('New vs Existing Buyers'),
      {
        text: [
          {
            text: 'Key Takeaways',
            options: {
              color: themeV2.colors.metricBlue,
              fontFace: DEFAULT_FONT,
              fontSize: 14,
              bold: true,
              breakLine: true,
              paraSpaceAfter: 6,
            },
          },
          {
            text: `Of the users exposed to media, ${props.newBuyerPercentage.toFixed(1)}% of users are considered New Buyers.`,
            options: {
              color: themeV2.colors.metricBlue,
              fontFace: DEFAULT_FONT,
              fontSize: 14,
              paraSpaceBefore: 6,
              paraSpaceAfter: 6,
            },
          },
        ],
        options: {
          x: 0.33,
          y: 5.96,
          w: 8.52,
          h: 1.08,
          valign: 'top',
        },
      },
    ],
  };
};
